import { render, staticRenderFns } from "./webviewer.vue?vue&type=template&id=2889c2cb"
import script from "./webviewer.vue?vue&type=script&lang=js"
export * from "./webviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports